import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const FileIcon = ({
  width = 24,
  height = 24,
  stroke = '#A0A4A8',
  strokeWidth = 2,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M14 2H6c-.53 0-1.04.21-1.414.586C4.21 2.96 4 3.47 4 4v16c0 .53.21 1.04.586 1.414C4.96 21.79 5.47 22 6 22h12c.53 0 1.04-.21 1.414-.586C19.79 21.04 20 20.53 20 20V8l-6-6z"
    />
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M14 2v6h6M16 13H8M16 17H8M10 9H8"
    />
  </svg>
);
